// Chairman has read-only access enforced server-side — backend/middleware/auth.js
// rejects any non-GET request for role === 'chairman' globally, regardless of
// which route it hits. That's the single source of truth for "chairman can't
// write." This helper is the frontend counterpart: it lets pages hide write
// affordances (Edit/Save/Pay/Confirm/etc.) so a read-only user isn't shown
// controls that would just fail with a 403 if clicked. Purely cosmetic —
// removing or bypassing this check changes nothing about what the backend
// will actually allow.
export function isChairmanReadOnly() {
  try {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    return user.role === 'chairman';
  } catch {
    return false;
  }
}
